(() => {
  const STORAGE_KEY = 'bio-cart-drawer-last-auto-opened-at';
  const AUTO_OPEN_COOLDOWN_MS = 30 * 60 * 1000;
  const PENDING_AUTO_OPEN_TIMEOUT_MS = 10 * 1000;

  let lastAutoOpenedAt = 0;
  let pendingAutoOpenSuppressionUntil = 0;
  let latestItemCount;
  let confirmationTimer;
  let lastConfirmationAt = 0;

  const getMiniCart = () => document.getElementById('mini-cart');

  const getLastAutoOpenedAt = () => {
    try {
      const storedTimestamp = Number.parseInt(window.sessionStorage.getItem(STORAGE_KEY) || '0', 10);
      if (Number.isFinite(storedTimestamp)) return storedTimestamp;
    } catch (error) {
      // Fall back to the in-memory timestamp when sessionStorage is unavailable.
    }

    return lastAutoOpenedAt;
  };

  const setLastAutoOpenedAt = (timestamp) => {
    lastAutoOpenedAt = timestamp;

    try {
      window.sessionStorage.setItem(STORAGE_KEY, String(timestamp));
    } catch (error) {
      // The in-memory timestamp still prevents repeated opens on this page.
    }
  };

  const isWithinAutoOpenCooldown = (now) => {
    const previousAutoOpenAt = getLastAutoOpenedAt();
    return (
      previousAutoOpenAt > 0 &&
      now >= previousAutoOpenAt &&
      now - previousAutoOpenAt < AUTO_OPEN_COOLDOWN_MS
    );
  };

  const resolveItemCount = () => {
    if (Number.isFinite(Number(latestItemCount))) return Number(latestItemCount);

    const countText = document.querySelector('[data-cart-count]')?.textContent || '';
    const itemCount = Number.parseInt(countText.match(/\d+/)?.[0], 10);
    return Number.isFinite(itemCount) ? itemCount : undefined;
  };

  const showAddConfirmation = () => {
    let toast = document.getElementById('BioCartAddConfirmation');

    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'BioCartAddConfirmation';
      toast.className = 'bio-atc-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.setAttribute('aria-atomic', 'true');
      toast.innerHTML = `
        <span class="bio-atc-toast__icon" aria-hidden="true">&#10003;</span>
        <span class="bio-atc-toast__copy">
          <span>Added to cart</span>
          <span class="bio-atc-toast__count" hidden></span>
        </span>
      `;
      document.body.appendChild(toast);
    }

    const itemCount = resolveItemCount();
    const countElement = toast.querySelector('.bio-atc-toast__count');

    if (countElement) {
      const hasItemCount = Number.isFinite(itemCount) && itemCount > 0;
      countElement.hidden = !hasItemCount;
      if (hasItemCount) {
        countElement.textContent = `${itemCount} ${itemCount === 1 ? 'item' : 'items'} in cart`;
      }
    }

    const now = Date.now();
    if (now - lastConfirmationAt < 500) return;
    lastConfirmationAt = now;

    const header = document.querySelector('[data-sticky-header]');
    const headerBottom = header?.getBoundingClientRect().bottom || 0;
    toast.style.setProperty('--bio-atc-toast-top', `${Math.max(16, Math.round(headerBottom + 12))}px`);

    window.clearTimeout(confirmationTimer);
    toast.classList.remove('is-visible');
    window.requestAnimationFrame(() => toast.classList.add('is-visible'));

    const cartBadge = document.querySelector('[data-cart-count-badge]');
    if (cartBadge) {
      cartBadge.classList.remove('is-confirmed');
      window.requestAnimationFrame(() => cartBadge.classList.add('is-confirmed'));
      window.setTimeout(() => cartBadge.classList.remove('is-confirmed'), 500);
    }

    confirmationTimer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
    }, 2500);
  };

  window.addEventListener('cart:changed', (event) => {
    const itemCount = event.detail?.cart?.item_count;
    if (Number.isFinite(Number(itemCount))) latestItemCount = Number(itemCount);
  });

  window.addEventListener('cart:item-added', () => {
    const miniCart = getMiniCart();
    if (!miniCart) return;

    const now = Date.now();
    const isAlreadyOpen = miniCart.classList.contains('is-open');

    if (isAlreadyOpen) {
      pendingAutoOpenSuppressionUntil = 0;
      if (!isWithinAutoOpenCooldown(now)) setLastAutoOpenedAt(now);
      return;
    }

    if (isWithinAutoOpenCooldown(now)) {
      pendingAutoOpenSuppressionUntil = now + PENDING_AUTO_OPEN_TIMEOUT_MS;
      return;
    }

    pendingAutoOpenSuppressionUntil = 0;
    setLastAutoOpenedAt(now);
  });

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest?.('[data-panel-trigger="mini-cart"]');
      if (!trigger || pendingAutoOpenSuppressionUntil <= Date.now()) return;

      if (event.isTrusted) {
        pendingAutoOpenSuppressionUntil = 0;
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      pendingAutoOpenSuppressionUntil = 0;
      showAddConfirmation();
    },
    true
  );

  window.addEventListener('panel:opened', (event) => {
    if (
      event.detail?.panelId !== 'mini-cart' ||
      pendingAutoOpenSuppressionUntil <= Date.now()
    ) {
      return;
    }

    pendingAutoOpenSuppressionUntil = 0;
    getMiniCart()?.querySelector('.panel-close')?.click();
    showAddConfirmation();
  });
})();
